import axios from 'axios';

async function ObtenerServiciosPlanes(prmFiltro: string = '', prmIdPlan: number = 0) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_servicios_planes"
    
    const datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "filtro": prmFiltro, "idplan": prmIdPlan}
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerServiciosPlanes;